import { render, staticRenderFns } from "./PaneTitle.vue?vue&type=template&id=cd7b1c5e&scoped=true&"
import script from "./PaneTitle.vue?vue&type=script&lang=js&"
export * from "./PaneTitle.vue?vue&type=script&lang=js&"
import style0 from "./PaneTitle.vue?vue&type=style&index=0&id=cd7b1c5e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7b1c5e",
  null
  
)

export default component.exports